export default __webpack_public_path__ + "static/media/UiEleve2.1c31e076.svg";